import React from 'react';

const FromInput = ({
  name = 'exampleName',
  type = 'text',
  placeholder = 'Enter whatever you want',
  required = true,
  errors,
  register,
}) => {
  return (
    <>
      <input
        {...register(name, { required })}
        type={type}
        // name={name}
        className={`py-2  ${
          errors?.[name] ? ' mb-0' : 'mb-4'
        }   px-4  w-full   border-black-200 border-2 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-white border-gray-500 dark:text-black`}
        placeholder={placeholder}
      />
      {errors?.[name] && (
        <p className='text-[12px] text-left text-red-500'>{name} is required</p>
      )}
    </>
  );
};

export default FromInput;
